import './index.scss'
import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import vSelect from 'vue-select'
import VModal from 'vue-js-modal'
import VCalendar from 'v-calendar'
import 'vue-select/dist/vue-select.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faPen, faEye, faTrash, faPlus, faSignOutAlt, faExclamation, faChevronDown } from '@fortawesome/free-solid-svg-icons'
import FadeLoader from 'vue-spinner/src/FadeLoader.vue'

Vue.use(VModal)
Vue.use(VCalendar)
Vue.component('v-select', vSelect)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('loader', FadeLoader)

library.add(faPen, faEye, faTrash, faPlus, faSignOutAlt, faExclamation, faChevronDown)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
